<template>
  <div
    class="map-grid"
    :class="{ 'map-grid--small': small, 'map-grid--interactive': interactive }"
    role="grid"
  >
    <div v-for="r in SIZE" :key="r" class="map-grid__row" role="row">
      <div
        v-for="c in SIZE"
        :key="c"
        class="map-cell"
        :class="cellClass(r - 1, c - 1)"
        role="gridcell"
        :data-pad="interactive ? '' : undefined"
        @pointerdown="interactive && $emit('cell', { r: r - 1, c: c - 1 })"
        @pointerenter="interactive && dragging && $emit('cell', { r: r - 1, c: c - 1 })"
      >
        <img
          v-if="tileFor(r - 1, c - 1)"
          class="map-cell__tile"
          :src="tileFor(r - 1, c - 1)"
          alt=""
          draggable="false"
        />
        <img
          v-else-if="isRuin(r - 1, c - 1)"
          class="map-cell__ruin"
          src="/tiles/ruins.png"
          alt="ruins"
          draggable="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
// One map sheet. Read-only thumbnails for the table, or the interactive
// sheet you draw on - the ghost preview is painted via cell classes so the
// grid never changes size while you line a shape up.
import { SIZE, isRuin, CHAR_TERRAIN } from '@/engine/board';

const TILE_SRC = {
  f: '/tiles/forest.png',
  v: '/tiles/village.png',
  a: '/tiles/farm.png',
  w: '/tiles/water.png',
  m: '/tiles/monster.png',
  M: '/tiles/mountain.png',
};

export default {
  name: 'MapGrid',
  props: {
    grid: { type: Array, required: true },
    small: { type: Boolean, default: false },
    interactive: { type: Boolean, default: false },
    // Ghost preview: { cells: [[r,c],...], terrain, legal }
    ghost: { type: Object, default: null },
    // While the pointer is down the ghost follows it across cells.
    dragging: { type: Boolean, default: false },
  },
  emits: ['cell'],
  data() { return { SIZE }; },
  computed: {
    ghostSet() {
      if (!this.ghost) return null;
      return new Set(this.ghost.cells.map(([r, c]) => `${r},${c}`));
    },
  },
  methods: {
    isRuin,
    tileFor(r, c) {
      return TILE_SRC[this.grid[r][c]] || null;
    },
    cellClass(r, c) {
      const classes = [];
      const ch = this.grid[r][c];
      if (ch !== '.') classes.push(`map-cell--${CHAR_TERRAIN[ch]}`);
      if (this.ghostSet?.has(`${r},${c}`)) {
        classes.push('map-cell--ghost');
        classes.push(this.ghost.legal ? `map-cell--ghost-${this.ghost.terrain}` : 'map-cell--ghost-bad');
      }
      return classes;
    },
  },
};
</script>
